import { tv } from 'tailwind-variants';

const tooltipStyles = tv({
    slots: {
        content: `
      iris:z-50
      iris:flex
      iris:max-w-xs
      iris:items-start
      iris:gap-2
      iris:self-stretch
      iris:rounded-(--comp-size-radius-tooltip)
      iris:border
      iris:border-(--comp-color-border-tooltip-default)
      iris:bg-(--comp-color-background-tooltip-default)
      iris:p-4
      iris:font-(family-name:--comp-type-font-tooltip)
      iris:text-(length:--comp-type-size-tooltip)
      iris:leading-(--comp-type-leading-tooltip)
      iris:font-(--comp-type-weight-tooltip)!
      iris:text-(--comp-color-content-tooltip-default)
      iris:shadow-elevation-04
      iris:ring-0
      iris:outline-0
      iris:data-[state=closed]:[animation:tooltipOut_var(--comp-motion-duration-tooltip)_var(--comp-motion-easing-tooltip)_forwards]
      iris:data-[state=open]:[animation:tooltipIn_var(--comp-motion-duration-tooltip)_var(--comp-motion-easing-tooltip)_forwards]
    `,
        arrow: `
      iris:relative
      iris:top-[-1.1px]
      iris:fill-(--comp-color-background-tooltip-default)
      iris:stroke-(--comp-color-border-tooltip-default)
      iris:stroke-[0.5px]
    `,
    },
    variants: {
        inverse: {
            true: {
                content: `
          iris:border-(--comp-color-border-tooltip-inverse)
          iris:bg-(--comp-color-background-tooltip-inverse)
          iris:text-(--comp-color-content-tooltip-inverse)
        `,
                arrow: `
          iris:fill-(--comp-color-background-tooltip-inverse)
          iris:stroke-(--comp-color-border-tooltip-inverse)
        `,
            },
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { tooltipStyles as default };
